import { useCallback } from 'react';
import { Button } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';

import { SelectedItemType, ItemIdentifiersType } from './types';

export const GWPOld_SelectedItem: React.FC<{
  item: SelectedItemType;
  removeSelectedItem: (i: ItemIdentifiersType) => void;
}> = ({ item, removeSelectedItem }) => {
  const translate = useTranslate();
  const onDelete = useCallback(
    () => removeSelectedItem(item),
    [item, removeSelectedItem]
  );
  return (
    <div
      className="bg-puma-black-800 py-2.5 px-4 mt-2.5"
      data-test-id="selected-bonus-item"
    >
      <div className="relative">
        <h3 className="font-bold">{item.productName}</h3>
        <Button
          className="absolute right-0 top-0"
          onClick={onDelete}
          label="delete"
          icon="trash"
          variant="ghost"
          mode="icon"
        />
      </div>
      <div className="flex text-sm">
        <p className="flex-1 flex space-x-2.5">
          <span className="text-puma-black-400">{translate('color')}</span>
          <span>{item.colorName}</span>
        </p>
        <p className="flex-1 flex space-x-2.5">
          <span className="text-puma-black-400">{translate('size')}</span>
          <span>{item.size?.label}</span>
        </p>
        <p className="flex-1 flex space-x-2.5">
          <span className="text-puma-black-400">{translate('quantity')}</span>
          <span>{item.quantity}</span>
        </p>
      </div>
    </div>
  );
};
